import { render, staticRenderFns } from "./Prijave.vue?vue&type=template&id=c2bff4d6&scoped=true&"
import script from "./Prijave.vue?vue&type=script&lang=js&"
export * from "./Prijave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bff4d6",
  null
  
)

export default component.exports